import { render, staticRenderFns } from "./PictureCardUpload.vue?vue&type=template&id=138f8fa1&scoped=true"
import script from "./PictureCardUpload.vue?vue&type=script&lang=js"
export * from "./PictureCardUpload.vue?vue&type=script&lang=js"
import style0 from "./PictureCardUpload.vue?vue&type=style&index=0&id=138f8fa1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138f8fa1",
  null
  
)

export default component.exports